<template>
  <small-subheader>
    <span class="title font-weight-medium">Manage Users</span>
    <template #action>
      <invite-user-dialog :users="users" @user-invited="$emit('user-invited', $event)" />
    </template>
  </small-subheader>
</template>

<script>
import SmallSubheader from '@/components/layout/SmallSubheader'
import InviteUserDialog from '@/components/manage/InviteUserDialog'

export default {
  components: { InviteUserDialog, SmallSubheader },
  props: {
    users: { type: Object, required: true }
  }
}
</script>
